import {
    defaultBaseQuery,
    transformErrorResponse,
    transformSuccessResponse,
    buildFormData
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const internshipapi = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'internshipapi',
    endpoints: (builder) => ({
        getInternships: builder.query({
            query: () => ({
                url: `/student/internships`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getInternshipById: builder.query({
            query: (internshipId) => ({
                url: `/student/internships/${internshipId}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        addInternship: builder.mutation({
            query: ({ requestDTO, certificate }) => ({
                url: '/student/internships/add',
                method: 'POST',
                body: buildFormData({ requestDTO, certificate })
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        updateInternship: builder.mutation({
            query: ({ requestDTO, certificate }) => ({
                url: '/student/internships/update',
                method: 'POST',
                body: buildFormData({ requestDTO, certificate })
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        deleteInternship: builder.mutation({
            query: (internshipId) => ({
                url: `/student/internships/delete`,
                method: 'DELETE',
                params: {
                    internshipId
                }
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    }),
});

export const {
    useLazyGetInternshipsQuery,
    useLazyGetInternshipByIdQuery,
    useAddInternshipMutation,
    useUpdateInternshipMutation,
    useDeleteInternshipMutation
} = internshipapi;

export default internshipapi;
